<template>
  <div id="app">
    <div  class="container">
      <div class="col-sm-8 mr-auto ml-auto">
        <Kalkulator/>
      </div>
    </div>
    <div id="copyright" class="text-center">
      Copyright © 2018 <a href="https://motofocus.pl/">MotoFocus.pl</a>
    </div>
  </div>
</template>

<script>
import Kalkulator from './components/Kalkulator'
import Vue from 'vue'
import VueClipboards from 'vue-clipboards'

Vue.use(VueClipboards)

export default {
  name: 'App',
  components: {
    Kalkulator
  }
}
</script>

<style>
#copyright{
  font-size: 12px;
  width: 100%;
  margin-top: 15px;
  margin-bottom: 15px;
  position: relative;
  opacity: 0.4;
}
#copyright a{
  font-weight: 700;
  color:#212529
}
</style>



// WEBPACK FOOTER //
// src/App.vue